import { isStandardVariant } from 'helpers/iconSizes';
import { ICON_SIZES } from 'lib/constants/iconSizes';

const WeightWatchers = ({ className = '', svgSize = ICON_SIZES.MD }) => {
  const isStandardVariantIcon = isStandardVariant(svgSize);

  if (isStandardVariantIcon) {
    return (
      <svg
        width={svgSize}
        height={svgSize}
        className={className}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_18_982)">
          <mask
            id="mask0_18_982"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="32"
            height="32"
          >
            <path d="M32 0H0V32H32V0Z" fill="white" />
          </mask>
          <g mask="url(#mask0_18_982)">
            <path
              d="M15.96 32.08C24.8186 32.08 32 24.8986 32 16.04C32 7.18135 24.8186 0 15.96 0C7.10134 0 -0.0800171 7.18135 -0.0800171 16.04C-0.0800171 24.8986 7.10134 32.08 15.96 32.08Z"
              fill="#0222D0"
            />
            <mask
              id="mask1_18_982"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="11"
              y="3"
              width="10"
              height="26"
            >
              <path d="M20.4299 3.20801H11.4564V28.6253H20.4299V3.20801Z" fill="white" />
            </mask>
            <g mask="url(#mask1_18_982)">
              <path
                d="M17.4032 3.20801L17.2288 9.91615H17.1051L16.8869 3.20801H15.1012L14.8976 9.90882H14.7673L14.6077 3.20801H12.7421L13.5841 13.4664H15.733L15.9 7.62226H16.031L16.1979 13.4664H18.3037L19.1457 3.20801H17.4032Z"
                fill="white"
              />
              <path
                d="M17.4032 18.3601L17.2288 25.0683H17.1051L16.8869 18.3601H15.1012L14.8976 25.0611H14.7673L14.6077 18.3601H12.7421L13.5841 28.6187H15.733L15.9 22.7743H16.031L16.1979 28.6187H18.3037L19.1457 18.3601H17.4032Z"
                fill="white"
              />
              <path d="M20.4299 15.0999H11.4565V16.726H20.4299V15.0999Z" fill="white" />
            </g>
          </g>
        </g>
        <defs>
          <clipPath id="clip0_18_982">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }

  return (
    <svg
      width={svgSize}
      height={svgSize}
      className={className}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.92 56C43.4936 56 56 43.4936 56 27.92C56 12.3464 43.4936 0 27.92 0C12.3464 0 0 12.3464 0 27.92C0 43.4936 12.3464 56 27.92 56Z"
        fill="#0222D0"
      />
      <path d="M30.5055 5.79201H20.9927V50.416H30.5055V5.79201Z" fill="white" />
      <path
        d="M24.8055 5.79201L24.4576 17.8323H24.2102L23.7738 5.79201H21.2024L20.7952 17.8164H20.4473L19.9999 5.79201H16.1131L17.5841 26.9327H21.1995L21.5999 13.2445H21.9999L22.4003 26.9327H26.0001L27.4711 5.79201H24.8055Z"
        fill="white"
      />
      <path
        d="M24.8055 36.7202L24.4576 48.7604H24.2102L23.7738 36.7202H21.2024L20.7952 48.7446H20.4473L19.9999 36.7202H16.1131L17.5841 57.8609H21.1995L21.5999 44.1727H21.9999L22.4003 57.8609H26.0001L27.4711 36.7202H24.8055Z"
        fill="white"
      />
      <path d="M30.5055 28.1998H20.9927V30.4516H30.5055V28.1998Z" fill="white" />
    </svg>
  );
};

WeightWatchers.propTypes = {
  className: PropTypes.string,
  svgSize: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default WeightWatchers;
